import { render, staticRenderFns } from "./qidonghuangyiyes.vue?vue&type=template&id=5fcbf48a&scoped=true&"
import script from "./qidonghuangyiyes.vue?vue&type=script&lang=js&"
export * from "./qidonghuangyiyes.vue?vue&type=script&lang=js&"
import style0 from "./qidonghuangyiyes.vue?vue&type=style&index=0&id=5fcbf48a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcbf48a",
  null
  
)

export default component.exports